export class PagedResultDto<ItemType> {
    TotalCount: number = 0;
    Items: ItemType[] = [];
}
